import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { StyledBladeOverlay } from './BladeOverlay.styled';
export var BladeOverlay = /*#__PURE__*/function (_React$Component) {
  function BladeOverlay() {
    var _this;
    _classCallCheck(this, BladeOverlay);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BladeOverlay, [].concat(args));
    _defineProperty(_this, "handleOverlayClick", function (ev) {
      if (ev.target === ev.currentTarget) {
        _this.props.onDismiss();
      }
    });
    return _this;
  }
  _inherits(BladeOverlay, _React$Component);
  return _createClass(BladeOverlay, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$overlayCl = _this$props.overlayClassName,
        overlayClassName = _this$props$overlayCl === void 0 ? '' : _this$props$overlayCl,
        children = _this$props.children;
      return /*#__PURE__*/React.createElement(StyledBladeOverlay, {
        animationState: this.props.transitionState,
        className: overlayClassName,
        onMouseDown: this.handleOverlayClick
      }, children);
    }
  }]);
}(React.Component);